
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const useLoginRedirect = () => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    if (isLoading) return;

    console.log("useLoginRedirect - Auth Status:", { 
      isAuthenticated, 
      isAdmin, 
      pathname: location.pathname,
      isLoading 
    });

    if (isAuthenticated) {
      const isOnLoginPage = location.pathname === "/login" || 
                           location.pathname === "/admin-login" ||
                           location.pathname === "/register" || 
                           location.pathname === "/registration";
      
      if (isOnLoginPage) {
        if (isAdmin) {
          console.log("Redirecting admin user to admin dashboard");
          navigate("/admin/dashboard", { replace: true });
        } else {
          console.log("Redirecting regular user to dashboard");
          navigate("/dashboard", { replace: true });
        }
      }
    }
  }, [isAuthenticated, isAdmin, navigate, location.pathname, isLoading]);
};
